import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Button, Modal, Form, FloatingLabel } from 'react-bootstrap';
import { NotifyModal } from '../../components/NotifyModal/NotifyModal';
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import ApiMServer from '../../services/ApiMServer';
import UnitsForm from './UnitsForm';
import Page from '../../components/Page/Page';
import AlertModal from '../../components/AlertModal/AlertModal';
import Reload from '../../components/reload/reload';
import Headers from '../../components/Headers/Headers';
import { useNavigate } from 'react-router-dom';
import 'react-multi-email/dist/style.css';

const Configuracoes = () => {
  const navigate = useNavigate();

  const { permissionSGU } = JSON.parse(localStorage.getItem('user'));
  if (permissionSGU?.settings?.read !== true) {
    navigate("/home");
  }

  const [units] = useState(JSON.parse(localStorage.getItem('units')) || [JSON.parse(localStorage.getItem('cooperative'))] || []);
  const [allUnits, setAllUnits] = useState([]);

  const [modalShow, setModalShow] = useState(false);
  const [type, setType] = useState({ color: "", status: "" });

  const [loading, setLoading] = useState(true);

  const [selectedUnits, setSelectedUnits] = useState([]);
  const [config, setConfig] = useState({
    configs: {
      maxHumidity: "30",
      minHumidity: "10",
      maxTemperature: "50",
      minTemperature: "10",
      maxPH: "90",
      minPH: "40",
      maxDensity: "900",
      minDensity: "400",
    },
    notification: {
      notifyTo: [],
      changeHumidity: false,
      changeTemperature: false,
      changePH: false,
      changeDensity: false,
      changeChart: false,
      changeCurve: false,
      measure: false,
      status: false
    },
    channel: {
      email: false,
      app: false,
      sms: false
    }
  })

  const [showModal, setShowModal] = useState(false);
  const [msg, setMsg] = useState({ title: "", message: "" });

  const [showModalExcluir, setShowModalExcluir] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleValidate = async () => {
    if (Number(config.configs.maxHumidity) < Number(config.configs.minHumidity)) {
      handleShow();
      setMsg({ title: "Alerta!", message: "O valor máximo de Umidade não pode ser menor que o mínimo!" });
      return
    } else if (Number(config.configs.maxPH) < Number(config.configs.minPH)) {
      handleShow();
      setMsg({ title: "Alerta!", message: "O valor máximo de PH não pode ser menor que o mínimo!" });
      return
    } else if (Number(config.configs.maxTemperature) < Number(config.configs.minTemperature)) {
      handleShow();
      setMsg({ title: "Alerta!", message: "O valor máximo de Temperatura não pode ser menor que o mínimo!" });
      return
    } else {
      handlePut()
    }
  }

  const openModalExcluir = (unit_id, email) => {
    setSelectedUnit(unit_id);
    setSelectedEmail(email);
    setShowModalExcluir(true);
  };

  const closeModalExcluir = () => {
    setSelectedEmail(null);
    setSelectedUnit(null);
    setShowModalExcluir(false);
  };

  const confirmDelete = () => {
    handleDeleteEmail();
    closeModalExcluir();
  };

  const handleUpdate = () => {
    setConfig((prevState) => ({
      ...prevState,
      notification: {
        ...prevState.notification,
        notifyTo: [],
      },
    }));
  };

  const handleDeleteEmail = async () => {
    try {
      const { data } = await ApiMServer.put(`/company/v1/delete-email-notify`, { selectedUnit, selectedEmail });
      handleGetUnits();
    } catch (error) {
      setType({ color: "red", status: "Erro ao atualizar!" });
      setModalShow(true);
    }
  }

  const handleGetFilterUnits = async (filter) => {
    try {
      const { data } = await ApiMServer.post(`/company/getfilterunits`, { filter: filter });
      setAllUnits(data);
    } catch (error) {
      setType({ color: "red", status: error?.response?.data?.status || "Erro ao carregar!" });
      setModalShow(true);
    }
  }

  const handlePut = async () => {
    if (!selectedUnits || !selectedUnits.length) {
      handleShow();
      setMsg({ title: "Alerta!", message: "Selecione uma ou mais Unidades para aplicar as configurações!" });
      return
    }

    try {
      const { data } = await ApiMServer.post(`/company/v1/updatecooperativesconfigs`, { selectedUnits, config });
      if (data.length) {
        handleGetUnits();
        handleUpdate();
        setType({ color: "#198754", status: "Atualizado com sucesso!" });
        setModalShow(true);
      } else {
        setType({ color: "red", status: "Erro ao atualizar!" });
        setModalShow(true);
      }
    } catch (error) {
      setType({ color: "red", status: "Erro ao atualizar!" });
      setModalShow(true);
    }
  }

  const handleGetUnits = () => {
    if (units.length) {
      let filter = units.map(unit => unit._id);
      handleGetFilterUnits(filter);
    }
  }

  useEffect(() => {
    handleGetUnits();
  }, [units]);

  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      const allUnitIds = allUnits.map(u => u._id);
      setSelectedUnits(allUnitIds);
    } else {
      setSelectedUnits([]);
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Page title={"Configurações"}>

      <Headers page={"Configurações"} />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <AlertModal
        show={showModal}
        handleClose={handleClose}
        msg={msg}
      />

      <Row className="d-flex align-items-stretch g-2">
        <Col xs={6}>
          <Card className='p-2 card-configuracoes'>
            <h4 className='mt-0'>Valores</h4>
            <hr />

            <Row className='mt-0 g-2'>
              <Col xs={12} sm={6} md={6} lg={3} xl={3} xxl={3}>
                <FloatingLabel controlId="maxUmidade" label="Max umidade" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Max umidade"
                    onChange={(event) => {
                      config.configs.maxHumidity = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.maxHumidity}
                    maxLength={6}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="minUmidade" label="Min umidade" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Min umidade"
                    onChange={(event) => {
                      config.configs.minHumidity = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.minHumidity}
                    maxLength={6}
                  />
                </FloatingLabel>
              </Col>

              <Col xs={12} sm={6} md={6} lg={3} xl={3} xxl={3}>
                <FloatingLabel controlId="maxTemperatura" label="Max temperatura" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Max temperatura"
                    onChange={(event) => {
                      config.configs.maxTemperature = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.maxTemperature}
                    maxLength={6}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="minTemperatura" label="Min temperatura" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Min temperatura"
                    onChange={(event) => {
                      config.configs.minTemperature = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.minTemperature}
                    maxLength={6}
                  />
                </FloatingLabel>
              </Col>

              <Col xs={12} sm={6} md={6} lg={3} xl={3} xxl={3}>
                <FloatingLabel controlId="maxDensidade" label="Max densidade" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Max densidade"
                    onChange={(event) => {
                      config.configs.maxDensity = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.maxDensity}
                    maxLength={6}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="minDensidade" label="Min densidade" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Min densidade"
                    onChange={(event) => {
                      config.configs.minDensity = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.minDensity}
                    maxLength={6}
                  />
                </FloatingLabel>
              </Col>

              <Col xs={12} sm={6} md={6} lg={3} xl={3} xxl={3}>
                <FloatingLabel controlId="maxPH" label="Max PH" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Max PH"
                    onChange={(event) => {
                      config.configs.maxPH = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.maxPH}
                    maxLength={6}
                  />
                </FloatingLabel>
                <FloatingLabel controlId="minPH" label="Min PH" className="mb-3">
                  <Form.Control
                    className='border-secondary'
                    type="number"
                    placeholder="Min PH"
                    onChange={(event) => {
                      config.configs.minPH = event.target.value;
                      setConfig({ ...config });
                    }}
                    defaultValue={config.configs.minPH}
                    maxLength={6}
                  />
                </FloatingLabel>
              </Col>

              <Col>
                <h4 className="mt-3">Notificações</h4>

                {[
                  { id: 'status', label: 'Online/Offline', field: 'status' },
                  { id: 'ph', label: 'Variação de PH', field: 'changePH' },
                  { id: 'curve', label: 'Mudança de Curva', field: 'changeCurve' },
                  { id: 'humidity', label: 'Variação de Umidade', field: 'changeHumidity' },
                  { id: 'density', label: 'Variação de Densidade', field: 'changeDensity' },
                  { id: 'temperature', label: 'Variação de Temperatura', field: 'changeTemperature' },
                ].map((notification) => (
                  <Form.Check key={notification.id} type="checkbox" id={`config-notification-${notification.id}`}>
                    <Form.Check.Input
                      type="checkbox"
                      onChange={(event) => {
                        config.notification[notification.field] = event.target.checked;
                        setConfig({ ...config });
                      }}
                      checked={config.notification[notification.field]}
                      disabled={!permissionSGU?.settings?.write}
                      isValid
                    />
                    <Form.Check.Label>{notification.label}</Form.Check.Label>
                  </Form.Check>
                ))}

                <h4 className="mt-3">Canais de Notificação</h4>

                {[
                  { id: 'mail', label: 'E-mail', field: 'email' },
                  { id: 'app', label: 'Aplicativo', field: 'app' },
                ].map((channel) => (
                  <Form.Check key={channel.id} type="checkbox" id={`config-channel-${channel.id}`}>
                    <Form.Check.Input
                      type="checkbox"
                      onChange={(event) => {
                        config.channel[channel.field] = event.target.checked;
                        setConfig({ ...config });
                      }}
                      checked={config.channel[channel.field]}
                      disabled={!permissionSGU?.settings?.write}
                      isValid
                    />
                    <Form.Check.Label>{channel.label}</Form.Check.Label>
                  </Form.Check>
                ))}

                <h4 className="mt-3">Lista de E-mails</h4>
                <ReactMultiEmail
                  className="mb-3"
                  placeholder="E-mails"
                  emails={config?.notification?.notifyTo}
                  onChange={(emails) => {
                    setConfig((prevState) => ({
                      ...prevState,
                      notification: {
                        ...prevState.notification,
                        notifyTo: emails,
                      },
                    }));
                  }}
                  validateEmail={(email) => {
                    return isEmail(email);
                  }}
                  getLabel={(email, index, removeEmail) => (
                    <div data-tag key={index}>
                      {email}
                      <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                      </span>
                    </div>
                  )}
                />
                <Button
                  size='sm'
                  variant="success"
                  onClick={() => {
                    handleValidate();
                  }}
                  disabled={!permissionSGU?.settings?.write}
                >
                  Salvar
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={6}>
          <Card className='p-2 card-configuracoes' style={{ overflowY: 'auto', overflowX: "hidden" }}>
            <Row className="align-items-center mb-0">
              <Col>
                <h4 className='mt-0'>Cooperativas</h4>
              </Col>
              <Col className="text-end d-flex align-items-center justify-content-end">
                <Form.Check type="checkbox" inline id="config-select-all-units-wrapper">
                  <Form.Check.Input
                    type="checkbox"
                    id="config-select-all-units-input"
                    onChange={handleSelectAllChange}
                    disabled={!permissionSGU?.settings?.write}
                    isValid
                  />
                  <Form.Check.Label>{'Todas'}</Form.Check.Label>
                </Form.Check>
              </Col>
            </Row>
            <hr />

            {allUnits.length ? (
              allUnits.map((item) => (
                <UnitsForm
                  key={item._id}
                  unit={item}
                  permissions={permissionSGU?.settings}
                  selectedUnits={selectedUnits}
                  setSelectedUnits={setSelectedUnits}
                  handleSelectAllChange={handleSelectAllChange}
                  openModalExcluir={openModalExcluir}
                />
              ))
            ) : (
              <p>Nenhuma unidade encontrada!</p>
            )}
          </Card>
        </Col>

      </Row>

      <Modal show={showModalExcluir} onHide={closeModalExcluir} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja excluir o e-mail <strong>{selectedEmail}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalExcluir}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>

    </Page>
  )
}
export default Configuracoes;
